import * as React from "react";
import Box from "@mui/material/Box";
import { PieChart } from "@mui/x-charts/PieChart";
import { useSelector } from "react-redux";

export default function PieGraphicUsers() {
  const { totalUsersAndroid, totalUsersIOS, totalUsersWeb } = useSelector(
    (state) => state.usersReducer
  );
  // console.log("totalUsersAndroid", totalUsersAndroid.length);
  // console.log("totalUsersIOS", totalUsersIOS.length);
  // console.log("totalUsersWeb", totalUsersWeb.length);
  const colors = ["#4A5568", "#CC5500", "#5D3FD3"];
  return (
    <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
      <PieChart
        height={350}
        width={350}
        slotProps={{
          legend: {
            direction: "row",
            position: { vertical: "bottom", horizontal: "middle" },
          },
        }}
        series={[
          {
            data: [
              {
                id: 0,
                value: totalUsersAndroid.length ?? 0,
                label: "Android",
                color: colors[0],
              },
              {
                id: 1,
                value: totalUsersIOS.length ?? 0,
                label: "iOS",
                color: colors[1],
              },
              {
                id: 2,
                value: totalUsersWeb.length ?? 0,
                label: "Web",
                color: colors[2],
              },
            ],
            innerRadius: 50,
            arcLabel: (params) => params.label ?? "",
            arcLabelMinAngle: 20,
          },
        ]}
      />
    </Box>
  );
}
